module.exports = __webpack_public_path__ + "assets/img/powered-by-moderlab.svg";